import React, { useEffect, useState, useContext } from "react";
import Module from "../../../../templates/components/Module";
import moment from "moment";
import Utilities from "../../../../../services/commonservice/utilities";
import Table2 from "../../../../templates/components/Table2";
import DatePicker from "../../../../templates/components/DatePicker";
import DimLoader from "../../../../templates/components/DimLoader";
import { store } from "../../../../../context/StateProvider";
import InvoiceService from "../../../../../services/api/invoice.service";
import PatientSelector from "../../../../templates/components/PatientSelector";
import ReportService from "../../../../../services/api/report.service";
import PracticeLocationSelector from "../../../../templates/components/PracticeLocationSelector";

const FinancialBenchmarkTable = (props) => {
  // context state and dispatch 
  const globalStateAndDispatch = useContext(store)
  const state = globalStateAndDispatch.state
  const [financialBenchmarkList, setFinancialBenchmarkList] = useState();
  const [isLoader, setIsLoader] = useState(false);
  const [startDate, setStartDate] = useState(moment().startOf("D"));
  const [endDate, setEndDate] = useState(moment().endOf("D"));
  const [initialMessage, setInitialMessage] = useState(true)
  const [isLocationClearable, setIsLocationClearable] = useState(state.providerSelected?.practiceLocationUsers?.length > 0 ? false : true)
  const [locationId, setLocationId] = useState(state.practiceLocationId || null)

  const onLocationChanged = (newLocationId) => {
    setLocationId(newLocationId)
  }
  const financialBenchmarkLookup = () => {
    let reqObj = {};
    if (locationId) {
      reqObj.PracticeLocationId = locationId
    }
    if (startDate) reqObj.StartDate = moment(startDate).toISOString()
    if (endDate) reqObj.EndDate = moment(endDate).toISOString()
    setIsLoader(true)
    setInitialMessage(false);
    ReportService.getFinancialBenchmarkReport(reqObj)
      .then((res) => {
        //console.log(JSON.stringify(res))
        setFinancialBenchmarkList(res);
        setIsLoader(false);
      })
      .catch((err) => {
        setFinancialBenchmarkList(res);
        setIsLoader(false);
      });
  };

  const columns = [
    {
      id: "providerName",
      Header: "Provider Name",
      accessor: (row) => row.providerName,
    },
    {
      id: "totalRevenue",
      Header: "Total Revenue $",
      accessor: (row) => {
        return row.totalRevenue ? Utilities.toDollar(row.totalRevenue) : "";
      },
      Footer: (info) => {
        const total = React.useMemo(
          () =>
            info.rows.reduce(
              (sum, row) => row.original.totalRevenue + sum,
              0
            ),
          [info.rows]
        );
        return <>{Utilities.toDollar(total)}</>;
      },
    },
    {
      id: "totalRetail",
      Header: "Total Retail $",
      accessor: (row) => {
        return row.totalRetail ? Utilities.toDollar(row.totalRetail) : "";
      },
      Footer: (info) => {
        const total = React.useMemo(
          () =>
            info.rows.reduce(
              (sum, row) => row.original.totalRetail + sum,
              0
            ),
          [info.rows]
        );
        return <>{Utilities.toDollar(total)}</>;
      },
    },
    {
      id: "totalServices",
      Header: "Total Services $",
      accessor: (row) =>
        row.totalServices ? row.totalServices : "",
    },
    {
      id: "membershipRevenue",
      Header: "Membership Revenue $",
      accessor: (row) => {
        return row.membershipRevenue
          ? Utilities.toDollar(row.membershipRevenue)
          : "";
      },
      Footer: (info) => {
        const total = React.useMemo(
          () =>
            info.rows.reduce(
              (sum, row) => row.original.membershipRevenue + sum,
              0
            ),
          [info.rows]
        );
        return <>{Utilities.toDollar(total)}</>;
      },
    },
    {
      id: "nonMembershipRevenue",
      Header: "Non-Membership Revenue $",
      accessor: (row) => {
        return row.nonMembershipRevenue
          ? Utilities.toDollar(row.nonMembershipRevenue)
          : "";
      },
      Footer: (info) => {
        const total = React.useMemo(
          () =>
            info.rows.reduce(
              (sum, row) => row.original.nonMembershipRevenue + sum,
              0
            ),
          [info.rows]
        );
        return <>{Utilities.toDollar(total)}</>;
      },
    },
    {
      id: "procedureCountsMembership",
      Header: "Membership Procedure Counts",
      accessor: (row) =>
        row.procedureCountsMembership || 0,
    },
    {
      id: "procedureCountsNonMembership",
      Header: "Non-Membership Procedure Counts",
      accessor: (row) =>
        row.procedureCountsNonMembership || 0,
    },
    {
      id: "appointmentHours",
      Header: "Appointment Hours",
      accessor: ({ appointmentHours = 0 }) => {
        const totalHours = Math.floor(appointmentHours);
        const totalMinutes = Math.round(
          (appointmentHours - totalHours) * 60
        );
        return appointmentHours > 0
          ? `${totalHours}h ${totalMinutes}min`
          : "";
      },
    },
    {
      id: "appointmentCount",
      Header: "Appointment Counts",
      accessor: (row) => row.appointmentCount || 0,
    },
    {
      id: "procedureCounts",
      Header: "	Procedure Counts",
      accessor: (row) => row.procedureCounts || 0,
    },
  ];


  return (
    <>
      {isLoader &&
        <DimLoader loadMessage="Processing" />
      }
      <div className="row d-flex g-3">
        <div className="col-12 m-p-0">
          <Module title="Filters">
            <div className='row d-flex'>
              <div className='col-12 mx-0  report-filters'>
                <div className="d-flex row justify-content-center align-items-end">
                  <DatePicker locationClearable={isLocationClearable} setLocationId={setLocationId} startDate={startDate} endDate={endDate} setEndDate={setEndDate} setStartDate={setStartDate} />
                  <div className="col-md-auto col-12"><button className="btn btn-primary" onClick={e => { e.preventDefault(); setFinancialBenchmarkList(); financialBenchmarkLookup() }} title="Pull Report"><i className="icon arrow circle right" /></button></div>
                </div>
              </div>
            </div>
          </Module>
        </div>
        <div className="col-12 m-p-0">
          <Module title="AGN FB">
            <Table2
              export
              searchable
              title="AGN FB"
              data={financialBenchmarkList}
              loading={isLoader}
              columns={columns}
              initialMessage={initialMessage}
            />
          </Module>
        </div>
      </div>
    </>
  );
};

export default FinancialBenchmarkTable;
